/* eslint-disable react-hooks/exhaustive-deps */
// import Cookies from 'js-cookie';
import { Inter_Tight } from 'next/font/google';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { ReactNode } from 'react';
import { useRecoilState } from 'recoil';
import { v4 as uuidv4 } from 'uuid';

import ErrorBoundary from '@/components/shared/ErrorBoundary';

// import UpgradeToPremiumModal from '@/components/Subscription/UpgradeToPremiumModal';
import ProductsHeader from './ProductsHeader';
import { extractSlugAndProductId } from '../BookLandingPageComp/SlidBookContainer';
import Footer from '../Footer';
// import { removeUserId, setUserId } from '../shared/getToken';
import { removeUserId } from '../shared/getToken';
// import { notify } from '../shared/notify';
import { tokenUpdate } from '../../atoms/authModalControl';
// import { chatCount } from '../../atoms/chatCount';
import { localCart } from '../../atoms/LocalCart';
import { localUserID, user } from '../../atoms/user';
import appwriteService, { setTokenInCookies } from '../../config/appwrite';
import { appWriteUser, useAuth } from '../../hooks/useAuth';
import usePageTracking from '../../hooks/usePageTracking';
// import { affiliateLinkClicks } from '../../services/Affiliate';
// import { getCartCount } from '../../services/Cart';
// import { getChatCount } from '../../services/Chat';
import { liveRegistrationAlreadyRegistered } from '../../services/Live';
// import { getUserProfile } from '../../services/user';
import { footerData } from '../../utils/data';
import useFirebaseNotifications from '../../utils/firebase/firebaseSetup';
import { register } from '../../utils/firebase/serviceWorkerRegistration';
import { AppwriteUserData, User } from '../../utils/interfaces/User';

interface Props {
  children: ReactNode;
}

export const interTight = Inter_Tight({
  subsets: ['latin'],
  fallback: ['Segoe UI', 'Roboto', 'Arial', 'sans-serif'],
  display: 'swap',
});

const Layout = ({ children }: Props) => {
  const router = useRouter();
  // const hasEffectRun = useRef(false);
  const [, setLocalCartCount] = useRecoilState(localCart);
  const [, setLocalUserId] = useRecoilState<string>(localUserID);
  const [, setIsTokenChanged] = useRecoilState(tokenUpdate);
  // const [isTokenChanged, setIsTokenChanged] = useRecoilState(tokenUpdate);
  // const [loggedIn] = useState<boolean>(false);
  // const [loggedIn, setLoggedIn] = useState<boolean>(false);
  // const [userData, setUserData] = useRecoilState<User | undefined>(user);
  const [userData] = useRecoilState<User | undefined>(user);
  // const [, setChatCount] = useRecoilState<number>(chatCount);
  const { setupNotifications, notification } = useFirebaseNotifications();
  const [notificationsSetup, setNotificationsSetup] = useState(false);
  const [showFooter, setShowFooter] = useState(false);

  const { asPath } = router;

  const {
    // afc,
    googleLoginCompleted,
    isRegister,
    bookId,
    appleLoginCompleted,
    // ref_code,
    courses_slug,
  } = router.query;
  const productId = extractSlugAndProductId(router.asPath);

  // const { handlePostSignUpData, onLogOut, identifyUserWithPostHog } = useAuth();
  const { handlePostSignUpData, identifyUserWithPostHog } = useAuth();

  // const isStagingEnv = ['staging', 'production'].includes(
  //   process.env.NEXT_PUBLIC_APP_ENV as string,
  // );

  const solePagePaths = [
    '/auth/forgot-password',
    '/auth/login/',
    '/auth/sign_up',
    '/shop',
    '/shop/bookDetails',
    '/shop/bundleDetails',
    '/privacy_policy/',
    '/error/',
    '/500',
    '/auth/reset-password',
    '/get-our-app',
    '/reader-personality-test',
    '/onboarding',
    '/iframePdfTest',
    '/auth-handler',
  ];

  // const authPagePaths = [
  //   '/my-orders/',
  //   '/manage-addresses/',
  //   '/profile/',
  //   '/library/',
  //   '/broadcast-message/',
  //   ...(isStagingEnv ? ['/notification/'] : []),
  //   '/pdf/',
  //   '/refer-earn/',
  //   '/rewards/',
  //   '/rewards/history/',
  //   '/onboarding/',
  //   '/reward-store/',
  //   '/gems-transactions/',
  // ];
  const links = [
    // { text: 'Home', route: '/' },
    { text: 'Books', route: '/books', type: 'books' },
    { text: 'Pricing', route: '/pricing', notHaveDropDown: true },
    // { text: 'Courses', route: '/courses', type: 'courses' },
    // {
    //   text: 'Schools',
    //   route: '/schools',
    //   type: 'schools',
    // },
    // { text: 'Live', route: '/live', type: undefined, notHaveDropDown: true },
    // {
    //   text: 'For Business',
    //   route: 'https://business.zebralearn.com/business',
    // },
    // { text: 'Contact Us', route: '/contact' },
  ];
  useEffect(() => {
    setShowFooter(false);

    const timer = setTimeout(() => {
      setShowFooter(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, [router.pathname]);

  const isSolePage =
    solePagePaths.includes(router.pathname) ||
    solePagePaths.includes(`${router.pathname}/`);

  // const isAuthenticated =
  //   authPagePaths.includes(router.pathname) ||
  //   authPagePaths.includes(`${router.pathname}/`) ||
  //   authPagePaths.some((path) => router.pathname.startsWith(path));

  // const checkAuthentication = async () => {
  //   try {
  //     await getUserProfile();
  //   } catch {
  //     notify('You are not authenticated', 'error');
  //     onLogOut();

  //     const redirectUrl = router.pathname.includes('/pdf')
  //       ? '/auth/login'
  //       : `/auth/login?redirectUrl=${router.pathname}`;

  //     router.push(redirectUrl);
  //   }
  // };

  // const handleChatCount = async () => {
  //   try {
  //     const data = await getChatCount();
  //     setChatCount(data?.messages);
  //   } catch (error: any) {
  //     if (process.env.NEXT_PUBLIC_APP_ENV === 'development') {
  //       console.error('Error initializing messaging:', error);
  //     }
  //   }
  // };

  // const setUpdatedProfile = async () => {
  //   try {
  //     const data = await getUserProfile();
  //     setUserData(data?.data);
  //     setUserId(data?.data?.id as string);
  //   } catch (error: any) {
  //     if (process.env.NEXT_PUBLIC_APP_ENV === 'development') {
  //       console.error('Error initializing messaging:', error);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   const fetchLoggedInStatus = async () => {
  //     const loggedInStatus = await appwriteService.isLoggedIn();
  //     setLoggedIn(loggedInStatus);
  //   };
  //   fetchLoggedInStatus();
  //   if (isTokenChanged) {
  //     setIsTokenChanged(false);
  //   }
  // }, [appwriteService.account, isTokenChanged, router.pathname]);

  // useEffect(() => {
  //   if (loggedIn) {
  //     setUpdatedProfile();
  //   }
  // }, [loggedIn]);

  // useEffect(() => {
  //   handleCartCount();
  // }, [router.pathname]);

  // useEffect(() => {
  //   if (loggedIn) {
  //     handleChatCount();
  //   }
  // }, [loggedIn, router.pathname]);

  // useEffect(() => {
  //   if (router.isReady && afc && !loggedIn) {
  //     Cookies.set('afc', afc as string, { expires: 7 });
  //     handleLinkClicks(afc as string);
  //   }
  //   if (router.isReady && ref_code) {
  //     Cookies.set('ref_code', ref_code as string, { expires: 30 });
  //   }
  // }, [afc, ref_code, router.isReady]);

  // useEffect(() => {
  //   if (router.isReady) {
  //     const query = router.query;

  //     if (typeof query === 'object' && query !== null) {
  //       const filteredQuery: { [key: string]: any } = {};

  //       for (const key in query) {
  //         if (Object.prototype.hasOwnProperty.call(query, key)) {
  //           if (
  //             typeof key === 'string' &&
  //             (key.startsWith('mc_') || key.startsWith('utm_'))
  //           ) {
  //             filteredQuery[key] = query[key];
  //           }
  //         }
  //       }
  //       if (Object.keys(filteredQuery).length > 0) {
  //         const filteredQueryStr = JSON.stringify(filteredQuery);
  //         const expireTime =
  //           Number(process.env.NEXT_PUBLIC_CASH_UTM_EXPIRY) || 7;
  //         Cookies.set('marketing_data', filteredQueryStr, {
  //           expires: expireTime,
  //         });
  //       }
  //     }
  //   }
  // }, [router]);

  // const handleLinkClicks = async (afc: string) => {
  //   try {
  //     await affiliateLinkClicks(afc);
  //   } catch (error: any) {
  //     if (process.env.NEXT_PUBLIC_APP_ENV === 'development') {
  //       console.error('Error initializing messaging:', error);
  //     }
  //   }
  // };

  // const handleCartCount = async (localId?: string) => {
  //   try {
  //     const data = await getCartCount({ localId });
  //     setLocalCartCount(data.count);
  //   } catch (error: any) {
  //     if (process.env.NEXT_PUBLIC_APP_ENV === 'development') {
  //       console.error('Error initializing messaging:', error);
  //     }
  //   }
  // };

  useEffect(() => {
    const setUserIdInLocalStorage = async () => {
      const existingUserId = localStorage.getItem('userId');

      if (!existingUserId) {
        const userId = uuidv4();

        localStorage.setItem('userId', userId);
        setTimeout(() => {
          setLocalCartCount(0);
          removeUserId();
        }, 2000);

        setLocalUserId(userId);
      }
      setLocalUserId(existingUserId as string);
    };

    setUserIdInLocalStorage();
  }, [router.asPath]);

  // useEffect(() => {
  //   if (isAuthenticated && !hasEffectRun.current) {
  //     checkAuthentication();
  //     hasEffectRun.current = true;
  //   }
  // }, [isAuthenticated, router, checkAuthentication]);

  const handleLiveRegistration = async (
    dbUser: User,
    isRegister: string,
    url: URL,
  ) => {
    try {
      await liveRegistrationAlreadyRegistered({
        email: dbUser?.email as string,
        live_workshop_slug: isRegister,
        name: dbUser?.name as string,
        ecom_user_id: dbUser?.id as number,
        phone: dbUser?.phone as string,
        country_code: dbUser?.country_code as string,
      });
      url.searchParams.delete('isRegister');
    } catch (error) {
      console.error('Live registration failed:', error);
    }
  };

  useEffect(() => {
    const fetchTokenAndTriggerChange = async () => {
      if (googleLoginCompleted === 'true' || appleLoginCompleted === 'true') {
        const token = await setTokenInCookies();

        if (
          router.pathname.includes('/auth/login') ||
          router.pathname.includes('/auth/sign_up')
        ) {
          router.push('/');
        }

        const user = await appwriteService.getCurrentUser();
        const currentUser = user as unknown as AppwriteUserData;
        const dbUser: User = await appWriteUser(currentUser?.userId as string);

        await handlePostSignUpData({
          dbUser,
          token: token as string,
          loginType: appleLoginCompleted ? 'apple' : 'google',
        });

        identifyUserWithPostHog({
          id: dbUser?.zl_uid as string,
          email: dbUser?.email,
          name: dbUser?.name,
        });

        setIsTokenChanged(true);

        if (
          !(
            router.pathname.includes('/auth/login') ||
            router.pathname.includes('/auth/sign_up')
          )
        ) {
          const url = new URL(asPath, window.location.origin);

          if (isRegister) {
            await handleLiveRegistration(dbUser, isRegister as string, url);
          }

          url.searchParams.delete('googleLoginCompleted');
          url.searchParams.delete('appleLoginCompleted');

          router.replace(url.pathname + url.search);
        }
      }
    };

    fetchTokenAndTriggerChange();
  }, [googleLoginCompleted, appleLoginCompleted, isRegister]);

  useEffect(() => {
    if (
      'Notification' in window &&
      'serviceWorker' in navigator &&
      'PushManager' in window &&
      userData &&
      !notificationsSetup
    ) {
      setupNotifications();
      register();
      notification();
      setNotificationsSetup(true);
    } else if (
      !('Notification' in window) ||
      !('serviceWorker' in navigator) ||
      !('PushManager' in window)
    ) {
      console.error('Notification not supported by your browser');
    }
  }, [userData, notificationsSetup]);

  useEffect(() => {
    if (!userData?.zl_uid || typeof window === 'undefined' || !window.posthog)
      return;

    const identifiedUserId = window.posthog.get_property?.('$user_id');

    if (identifiedUserId !== userData.zl_uid) {
      window.posthog.identify?.(userData.zl_uid, {
        email: userData.email,
        name: userData.name,
      });
    }
  }, [userData?.zl_uid]);

  usePageTracking();

  return (
    <>
      <span suppressHydrationWarning className={interTight.className}>
        {!isSolePage ? (
          <ProductsHeader
            isShadow={router.asPath === '/about_us/'}
            links={links}
          />
        ) : null}
        <ErrorBoundary fallback={<div>Error rendering page.</div>}>
          <div key={router.asPath}>
            {children ?? <div>Page content failed to load</div>}
          </div>
        </ErrorBoundary>
        {!isSolePage &&
          router.isReady &&
          router.pathname !== '/cart' &&
          router.pathname !== '/checkout' &&
          router.pathname !== '/broadcast-message' &&
          router.pathname !== '/personality_test' &&
          router.pathname !== '/onboarding' &&
          !router.pathname.includes('watch') &&
          !router.pathname.includes('/pdf') &&
          !courses_slug &&
          showFooter &&
          !(bookId && productId) && (
            <Footer navigation={footerData.navigation} />
          )}
        {/* <UpgradeToPremiumModal /> */}
      </span>
    </>
  );
};
export default Layout;
